import axios from "axios";

export const CUSTOMERS_URL = "api/customers";

axios.defaults.headers.post["Content-Type"] = "application/json";


// CREATE =>  POST: add a new customer to the server
export function createCustomer(customer) {
  return axios.post(CUSTOMERS_URL, { customer });
}

// READ
export function getAllCustomers() {
  return axios.get(CUSTOMERS_URL);
}

export function getCustomerById(customerId) {
  return axios.get(`${process.env.REACT_APP_API_URL}/api/users/${customerId}`);
}

export function getCustomerDetailsById(customerId) {
  return axios.get(`${process.env.REACT_APP_API_URL}/api/users/details/${customerId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findCustomers(queryParams) {
  return axios.post(`${process.env.REACT_APP_API_URL}/api/users?group=false`, JSON.stringify(queryParams));
}

// UPDATE => PUT: update the customer on the server
export function updateCustomer(customer) {
  return axios.put(`${process.env.REACT_APP_API_URL}/api/users/${customer._id}`, { customer });
}

// UPDATE Status
export function updateStatusForCustomers(ids, status) {
  return axios.put(`${process.env.REACT_APP_API_URL}/api/users/state/ids`, {
    ids,
    status
  });
}

// DELETE => delete the customer from the server
export function deleteCustomer(customerId) {
  return axios.put(`${process.env.REACT_APP_API_URL}/api/users/state/${customerId}`);
}

// DELETE Customers by ids
export function deleteCustomers(ids) {
  return axios.post(`${CUSTOMERS_URL}/deleteCustomers`, { ids });
}
